// test2093
(2093 && 0);
